import React from 'react';

import { ChargingStationInterFace } from '../../../interface/charging-station.interface';

import RejectedElectricityPrice from './RejectedElectericityPrice';
import RejectedStationList from './RejectedStationList';

interface UnapprovedListingProperties {
  viewFunction: (value: ChargingStationInterFace) => void;
  currentPage: string;
  setCurrentPage: (value: string) => void;
  handleDeleteStationWarning: (value: string | undefined) => void;
}

/**
 * Function to toggle between unapproved station and unapproved electric price
 * @returns
 */
function RejectedListing(properties: UnapprovedListingProperties) {
  const { currentPage, setCurrentPage, handleDeleteStationWarning } = properties;

  return (
    <div className="unapproved-list-toggle-wrap">
      {currentPage === 'station' && (
        <RejectedStationList
          handleDeleteStationWarning={handleDeleteStationWarning}
        />
      )}
      {currentPage === 'electricityPrice' && (
        <RejectedElectricityPrice currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}
    </div>
  );
}

export default RejectedListing;
